export default __webpack_public_path__ + "static/media/default_author.1384d78f.png";